module.exports = __webpack_public_path__ + "img/output-onlinegiftools (26).3e41116f.gif";